import { render } from "./ViewTotal.vue?vue&type=template&id=69124116&scoped=true"
import script from "./ViewTotal.vue?vue&type=script&lang=js"
export * from "./ViewTotal.vue?vue&type=script&lang=js"

import "./ViewTotal.vue?vue&type=style&index=0&id=69124116&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69124116"]])

export default __exports__